import Vue from 'vue'
import { UserService} from '@/common/api.service'
import { SortUtils } from '@/common/utils.js'

import {
    FETCH_USER,
    USER_RESET_STATE
} from './actions.type'

import {
    SET_USER,
    RESET_USER_STATE,
} from './mutations.type'

const initialState = {
    user: {},
}

export const state = Object.assign({}, initialState)

export const actions = {
    [FETCH_USER] (context) {
        if(state.user !== {}) {
            return UserService.get('me')
            .then(({ data }) => {
                context.commit(SET_USER, data)
                return data
            })
        }
    },
    [USER_RESET_STATE] ({ commit }) {
        commit(RESET_STATE)
    }
}

export const mutations = {
    [SET_USER] (state, user) {
        state.user = user
    },
    [RESET_USER_STATE] () {
        for (let f in state) {
          Vue.set(state, f, initialState[f])
        }
    }
}

const getters = {
    user (state) {
        return state.user
    },
  }

export default {
    state,
    actions,
    mutations,
    getters
}